module.exports = __webpack_public_path__ + "static/img/xiazaiyouli.262e84d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/xiazaiyouli.png
// module id = v7fZ
// module chunks = 69